<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_system_users'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-show="userData.permissions['new_system_user'] == 1" v-b-modal.new-user size="sm"
                variant="primary"><i class="mdi mdi-plus"></i> New User</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(full_name)="data">
                  <router-link :to="{
                    path: '/member-profile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id }}</span>
                    </span>
                  </router-link>
                </template>
                <template #cell(contact)="data">
                  {{ data.item.member.telephone }}
                </template>
                <template #cell(role)="data">
                  <!-- Highlight the Super Admin role -->
                  <span
                    v-if="data.item.role && (data.item.role.name === 'Super Administrator' || data.item.role.name === 'Super Admin')">
                    <span class="badge bg-info py-1 px-2 text-white" style="font-size: 0.85em;"><i
                        class="fas fa-user-shield"></i> Super Admin</span>
                  </span>
                  <span v-else>
                    {{ data.item.role ? data.item.role.name : '' }}
                  </span>
                </template>
                <template #cell(address)="data">
                  {{ data.item.member.address }}
                </template>
                <template #cell(actions)="data">
                  <span v-if="data.item.username == userData.username">
                    <b-button @click="changepass(data.item.id, data.item.username)" type="button" class="btn-sm btn"
                      variant="info" v-b-modal.password> <i class="mdi mdi-lock"></i> </b-button>
                  </span>
                  <span v-else>
                    <div class="btn-group">
                      <b-button v-show="userData.permissions['edit_system_user'] == 1"
                        @click="changepass(data.item.id, data.item.username)" type="button" class="btn-sm btn"
                        variant="info" v-b-modal.password> <i class="mdi mdi-lock"></i> </b-button>
                      <b-button v-if="!(data.item.role && (data.item.role.name === 'Super Administrator' || data.item.role.name === 'Super Admin'))" v-show="userData.permissions['delete_system_user'] == 1"
                        @click="remove(data.item.id, data.item.username)" type="button" class="btn-sm btn"
                        variant="danger" v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                    </div>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view System Users</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-user" centered title="New System User" title-class="font-18" hide-footer>
      <form @submit.prevent="addUser">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select :options="members" placeholder="Select an Option" v-model="member" label="name"
            :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Role</label>
          <b-form-select v-model="role" :options="roles" class="mb-3 form-control" value-field="id"
            text-field="name"></b-form-select>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-user')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="change-user" centered title="Change User Password" title-class="font-18" hide-footer>
      <form @submit.prevent="editUserPassword">
        <input v-model="id" type="hidden">
        <div class="form-group mb-2">
          <label>Password for <b>{{ fullname }}</b></label>
          <input v-model="password" type="text" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('change-user')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-user" centered title="Delete System User" title-class="font-18" hide-footer>
      <form @submit.prevent="removeUser">
        <input v-model="id" type="hidden">
        Are you sure you want to delete the User : <b>{{ fullname }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-user')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
// import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { userMethods, userComputed, memberMethods, memberComputed, roleMethods, roleComputed } from "@/state/helpers";

export default {
  page: {
    title: "System Users",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "System Users",
      items: [{ text: "Dashboard", to: "/", }, { text: "System Users", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'full_name', label: 'Full Name', visible: true },
        // { key: 'contact', label: 'Contact', visible: true },
        // { key: 'address', label: 'Address', visible: true },
        { key: 'username', label: 'Username', visible: true },
        { key: 'role', label: 'Role', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      member: '',
      role: '',
      password: '',
      fullname: '',
      name_hover: false,
      current_index: null,
    };
  },
  computed: {
    ...userComputed,
    ...roleComputed,
    ...memberComputed,
    List() { return this.users.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.users.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.users.length > 0) { a = false; } else { a = true; } return a },
  },
  mounted() {
    this.fetchUsers();
    this.fetchRoles();
    this.fetchMembers();
    this.TotalRows = this.users.length;
    this.isBusy = false;
  },
  methods: {
    ...userMethods,
    ...roleMethods,
    ...memberMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    changepass(id, fullname) {
      this.id = id;
      this.fullname = fullname;
      this.$bvModal.show('change-user')
    },
    remove(id, fullname) {
      this.id = id;
      this.fullname = fullname;
      this.$bvModal.show('delete-user')
    },
    async addUser() {
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("role", this.role);
      let url = "/addsystemuser";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('new-user');
          this.member = "";
          this.role = "";
        }
      });
    },
    async editUserPassword() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("password", this.password);
      let url = "/updateserpassword";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('change-user');
        }
      });
    },

    async removeUser() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removesystemuser";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchUsers();
          this.$bvModal.hide('delete-user');
        }
      });
    },
  },
};
</script>